<!-- eslint-disable vue/valid-v-bind -->
<template>
  <div class="progressbar" :class="{ 'progressbar--month': month }">
    <svg
      class="progressbar__circle"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
    >
      <circle
        class="progressbar__background"
        cx="12"
        cy="12"
        r="12"
        :fill="month ? 'transparent' : 'rgba(1, 1, 1, 0.09)'"
      />
      <circle
        class="progressbar__progress"
        cx="12"
        cy="12"
        r="9"
        :fill="!month ? 'white' : 'rgba(250, 250, 250, 1)'"
      />
      <circle
        class="progressbar__stroke"
        cx="12"
        cy="12"
        r="10.5"
        :stroke="fillColor"
        :stroke-width="3"
        :stroke-dasharray="dashArray"
        :stroke-dashoffset="dashOffset"
        :transform="`rotate(${rotate} 12 12)`"
        fill="transparent"
      />
    </svg>
    <div class="progressbar__month-day" v-if="month">{{ monthDay }}</div>
    <svg v-if="check" class="progressbar__step" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0863 11.3555H6.35197C6.16391 11.3555 5.98627 11.4461 5.86999 11.6015C5.75372 11.7568 5.71165 11.9596 5.75593 12.1517C6.10696 13.6756 6.67414 15.2334 8.21915 15.2334C9.76415 15.2334 10.3313 13.6756 10.6824 12.1517C10.7266 11.9596 10.6846 11.7568 10.5683 11.6015C10.452 11.4461 10.2744 11.3555 10.0863 11.3555Z" :fill="checkColor"/>
      <path d="M8.21915 1C7.39624 1 6.67133 1.34521 6.12279 1.99829C5.11888 3.19351 4.78588 5.27891 5.13307 8.19658C5.19124 8.6847 5.2455 9.11194 5.29889 9.50274C5.34227 9.82007 5.6009 10.0557 5.90594 10.0557H10.5324C10.8374 10.0557 11.096 9.82007 11.1394 9.50274C11.193 9.11074 11.2472 8.6835 11.3052 8.19658C11.3052 8.19662 11.3052 8.19653 11.3052 8.19658C11.6524 5.279 11.3194 3.19355 10.3155 1.99829C9.76698 1.34521 9.04211 1 8.21915 1Z" :fill="checkColor"/>
      <path d="M17.648 19.1221H13.9137C13.7256 19.1221 13.548 19.2127 13.4317 19.3681C13.3154 19.5234 13.2733 19.7262 13.3176 19.9183C13.6686 21.4422 14.2358 23 15.7808 23C17.3258 23 17.893 21.4422 18.2441 19.9183C18.2883 19.7262 18.2463 19.5234 18.13 19.3681C18.0137 19.2127 17.8361 19.1221 17.648 19.1221Z" :fill="checkColor"/>
      <path d="M17.8772 9.76489C17.3287 9.11181 16.6038 8.7666 15.7809 8.7666C14.9579 8.7666 14.233 9.11181 13.6845 9.76489C12.6806 10.9601 12.3476 13.0455 12.6948 15.9632C12.7528 16.4501 12.807 16.8774 12.8606 17.2693C12.904 17.5867 13.1626 17.8223 13.4676 17.8223H18.0941C18.3991 17.8223 18.6577 17.5867 18.7011 17.2693C18.7545 16.8785 18.8088 16.4513 18.8669 15.9632C18.8669 15.9632 18.8669 15.9631 18.8669 15.9632C19.2141 13.0456 18.8811 10.9601 17.8772 9.76489Z" :fill="checkColor"/>
    </svg>
  </div>
</template>

<script>
const colors = {
  success: '#71D13D',
  warning: '#93DE64',
  danger: '#B5EB8F',
  default: 'rgba(0,0,0, 0.09)',
};

export default {
  props: {
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    targetSteps: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 68,
    },
    check: {
      type: Boolean,
      default: true,
    },
    month: {
      type: Boolean,
      default: false,
    },
    monthDay: {
      type: [String, Number],
    },
    rotate: {
      type: Number,
      default: 90,
    },
  },
  computed: {
    dashArray() {
      const radius = 10.5; // Убедитесь, что этот радиус соответствует вашим кругам
      const circumference = 2 * Math.PI * radius;
      return `${circumference}`;
    },
    dashOffset() {
      const radius = 10.5; // Убедитесь, что этот радиус соответствует вашим кругам
      const circumference = 2 * Math.PI * radius;
      const percentage = Math.min(this.targetSteps, Math.max(0, this.value)) / this.targetSteps;
      return circumference * (1 - percentage);
    },
    strokeWidth() {
      return this.size / 10; // Ширина обводки изменится в зависимости от нового размера
    },
    checkColor() {
      if (this.value === 0 && this.targetSteps === 0) {
        return colors.default;
      }
      return this.value >= this.targetSteps ? colors.success : colors.default;
    },
    fillColor() {
      if (this.value === 0 && this.targetSteps === 0) {
        return null;
      }
      if (this.targetSteps === 0) {
        return colors.danger;
      }
      const percentage = (this.value / this.targetSteps) * 100;
      if (percentage >= 100) {
        return colors.success; // Зеленый
      }
      if (percentage >= 50) {
        return colors.success; // Зеленый (50-99%)
      }
      return colors.danger;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./ProgressBarCircle";
.progressbar {
  background-color: rgba(250, 250, 250, 1);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12),0px 1px 1px 0px rgba(0, 0, 0, 0.08);
  border-radius: 50%;
  &.outside {
    opacity: 0.4;
  }
}
</style>
